var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"mobile-breakpoint":0,"headers":_vm.headers,"items":_vm.itemsWithSno,"loading":_vm.loading,"footer-props":{ 'items-per-page-options': [25, 50, 100, 500] }},scopedSlots:_vm._u([{key:"item.dietPlan",fn:function(ref){
var item = ref.item;
return [(item.dietPlan)?_c('span',[_vm._v(" "+_vm._s(item.dietPlan.nameEn)+" ")]):_vm._e()]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('RemovePackage',{attrs:{"celebrity":_vm.celebrity,"package":item}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }